export const DETAIL_TABS = {
  DRIVER: 'driver',
  ORDER: 'order',
  PARTNER: 'partner',
};
